// GA4 event helper — analytics must never break the app.
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch {
    /* no-op */
  }
};
